import Text from '@components/Text';
import styled from '@emotion/styled';
import { HTMLAttributes, ReactNode } from 'react';

import CheckedIcon from './CheckedIcon';
import DefaultIcon from './DefaultIcon';

export interface Props extends HTMLAttributes<HTMLDivElement>{
    isChecked?: boolean;
    toggleCheckbox?: () => void;
    children?: ReactNode;
    disabled?: boolean;
}

function Checkbox(props: Props) {
    const {
        isChecked, toggleCheckbox, children, disabled, ...rest
    } = props;
    return (<Container aria-label='checkbox'
        aria-disabled={disabled}
        onClick={(e) => {
            if (toggleCheckbox) {
                e.preventDefault();
                e.stopPropagation();
                toggleCheckbox?.();
            }
        }}
        {...rest}>
        {isChecked ? <CheckedIcon/> : <DefaultIcon/>}
        <FullText as='div' >{children}</FullText>
    </Container>);
}

const Container = styled.div`
    align-items: center;
    column-gap: 8px;
    cursor: pointer;
    display: flex;
    flex-wrap: nowrap;
    padding-right: 10%;
    width: 100%;

    &[aria-disabled=true] {
        opacity: .5;
    }
`;

const FullText = styled(Text)`
    flex: 1;
`;

export default Checkbox;
